import monstadt from "./inMonstadt";
import liyue from "./inLiyue";
import inazuma from "./inInazuma";
import sumeru from "./inSumeru";
import purpleOnly from "./purpleOnly";

// total 34
const artifacts = sumeru.concat(monstadt, liyue, inazuma, purpleOnly);

export default artifacts;
